import React, { ReactElement } from "react";
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@bolt/components";

import { AskGPCLogo, ChatGPCLogo } from "../Logos/Logos";
import { ROUTES } from "../../config/routes";
import { useUserGroups } from "../../hooks";
import { useFeatureFlags } from "../../contexts/FeatureFlagsContext";
import { AppType } from "../../types";

import "./AppSelector.css";

const APP_COMPONENTS: { [key in AppType]: ReactElement } = {
  [AppType.askGpc]: <AskGPCLogo />,
  [AppType.chatGpc]: <ChatGPCLogo />,
};

export const AppSelector = ({ selectedApp, setApp }: { selectedApp: AppType; setApp: (appType: AppType) => void }) => {
  const groups = useUserGroups();
  const { isAskGpcEnabled } = useFeatureFlags();

  return isAskGpcEnabled && groups.askGpc ? (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button intent="neutral" iconRight="chevron-down" variant="ghost" className="app-selector-trigger">
          {APP_COMPONENTS[selectedApp]}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {Object.values(AppType).map((appType: AppType) => (
          <DropdownMenuItem className="app-selector-item" key={appType} onClick={() => setApp(appType)}>
            {APP_COMPONENTS[appType]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  ) : (
    <a href={ROUTES.INDEX} className="app-selector-trigger">
      <ChatGPCLogo />
    </a>
  );
};
